/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital.reducer';

export const HospitalDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalEntity = useAppSelector(state => state.hospital.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospital.detail.title">Hospital</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospital.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.hospital.name">Name</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.name}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.hospital.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.hospital.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.createdBy}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospital.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospital.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospital.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospital.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospital.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.cursor}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.hospital.email">Email</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.email}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.hospital.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.registrationCode}</dd>
          <dt>
            <span id="registrationAuth">
              <Translate contentKey="tinyMedicRestApp.hospital.registrationAuth">Registration Auth</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.registrationAuth}</dd>
          <dt>
            <span id="registrationState">
              <Translate contentKey="tinyMedicRestApp.hospital.registrationState">Registration State</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.registrationState}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.hospital.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.taxCode}</dd>
          <dt>
            <span id="billPrefix">
              <Translate contentKey="tinyMedicRestApp.hospital.billPrefix">Bill Prefix</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.billPrefix}</dd>
          <dt>
            <span id="panNumber">
              <Translate contentKey="tinyMedicRestApp.hospital.panNumber">Pan Number</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.panNumber}</dd>
          <dt>
            <span id="tanNumber">
              <Translate contentKey="tinyMedicRestApp.hospital.tanNumber">Tan Number</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.tanNumber}</dd>
          <dt>
            <span id="ownPanels">
              <Translate contentKey="tinyMedicRestApp.hospital.ownPanels">Own Panels</Translate>
            </span>
          </dt>
          <dd>{hospitalEntity.ownPanels ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospital.contactCode">Contact Code</Translate>
          </dt>
          <dd>{hospitalEntity.contactCode ? hospitalEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospital.user">User</Translate>
          </dt>
          <dd>{hospitalEntity.user ? hospitalEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital/${hospitalEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalDetail;
